import { useRef } from 'react';
import {
  IonContent,
  IonPage,
  IonFab,
  IonFabButton,
  IonIcon,
  IonButton,
} from '@ionic/react';
import {
  arrowUpOutline,
  arrowDownOutline,
  arrowBackOutline,
  arrowForwardOutline,
  homeOutline,
} from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useGame } from '../hooks/useGame';
import { Direction, GamePhase } from '../game/types';
import './Game.css';

const Game: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { state, setDirection } = useGame(canvasRef);
  const history = useHistory();

  const isGameOver = state?.phase === GamePhase.GameOver;

  return (
    <IonPage>
      <IonContent fullscreen scrollY={false} className="game-content">
        <div className="game-wrapper">
          <canvas ref={canvasRef} className="game-canvas" />

          {isGameOver && (
            <div className="game-over-overlay">
              <h2>Game Over</h2>
              <p>Score: {state?.score ?? 0}</p>
              <p>Level: {state?.level ?? 1}</p>
              <IonButton color="primary" onClick={() => history.push('/home')}>
                <IonIcon slot="start" icon={homeOutline} />
                Home
              </IonButton>
              <IonButton color="secondary" onClick={() => window.location.reload()}>
                Play Again
              </IonButton>
            </div>
          )}
        </div>

        <div className="dpad-container" aria-label="Directional controls">
          <button className="dpad-btn dpad-up" onPointerDown={() => setDirection(Direction.Up)}>
            <IonIcon icon={arrowUpOutline} />
          </button>
          <button className="dpad-btn dpad-left" onPointerDown={() => setDirection(Direction.Left)}>
            <IonIcon icon={arrowBackOutline} />
          </button>
          <button className="dpad-btn dpad-right" onPointerDown={() => setDirection(Direction.Right)}>
            <IonIcon icon={arrowForwardOutline} />
          </button>
          <button className="dpad-btn dpad-down" onPointerDown={() => setDirection(Direction.Down)}>
            <IonIcon icon={arrowDownOutline} />
          </button>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Game;
